var map = {
	"./eLearn-01.png": 93086,
	"./eLearn-01_en.png": 81852,
	"./eLearn-02.png": 93598,
	"./eLearn-03.png": 42799,
	"./eLearn-04.png": 2568,
	"./eLearn-05.png": 68166,
	"./eLearn-06.png": 54121,
	"./eLearn-07.png": 91786,
	"./eLearn-bg-01.png": 8380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63505;